"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderAccount = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_intl_1 = require("react-intl");
var Overlay_1 = require("../Overlay");
var WrappedHeaderAccount = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedHeaderAccount, _super);
    function WrappedHeaderAccount(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleAccountMenu = function (isOpen) {
            if (isOpen === void 0) { isOpen = !_this.state.isOpen; }
            _this.setState({
                isOpen: isOpen,
            });
        };
        _this.toggleAccountMenuHandler = function () {
            _this.toggleAccountMenu();
        };
        _this.state = {
            isOpen: false,
        };
        return _this;
    }
    WrappedHeaderAccount.prototype.getClassNames = function () {
        var _a;
        return classnames_1.default((_a = {
                "gd-header-account": true,
                "is-open": this.state.isOpen
            },
            _a[this.props.className] = !!this.props.className,
            _a));
    };
    WrappedHeaderAccount.prototype.getMenuItems = function () {
        var _this = this;
        return this.props.items.map(function (item) {
            return (react_1.default.createElement("a", { key: item.key, href: item.href, onClick: function (e) {
                    _this.menuItemClicked(item, e);
                }, className: "gd-list-item " + item.className },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: item.key })));
        });
    };
    WrappedHeaderAccount.prototype.menuItemClicked = function (item, e) {
        this.toggleAccountMenu(false);
        this.props.onMenuItemClick(item, e);
    };
    WrappedHeaderAccount.prototype.renderAccountMenu = function () {
        var _this = this;
        return this.state.isOpen ? (react_1.default.createElement(Overlay_1.Overlay, { alignTo: ".gd-header-account", alignPoints: [
                {
                    align: "br tr",
                },
            ], closeOnOutsideClick: true, closeOnMouseDrag: true, closeOnParentScroll: true, onClose: function () {
                _this.toggleAccountMenu(false);
            } },
            react_1.default.createElement("div", { className: "gd-dialog gd-dropdown overlay gd-header-account-dropdown" },
                react_1.default.createElement("div", { className: "gd-list small" }, this.getMenuItems())))) : (false);
    };
    WrappedHeaderAccount.prototype.render = function () {
        return (react_1.default.createElement("div", { className: this.getClassNames(), onClick: this.toggleAccountMenuHandler },
            react_1.default.createElement("span", { className: "gd-header-account-icon gd-icon-user" }),
            react_1.default.createElement("span", { className: "gd-header-account-user" }, this.props.userName),
            this.renderAccountMenu()));
    };
    WrappedHeaderAccount.defaultProps = {
        className: "",
        items: [],
        userName: "",
    };
    return WrappedHeaderAccount;
}(react_1.PureComponent));
exports.HeaderAccount = react_intl_1.injectIntl(WrappedHeaderAccount);
//# sourceMappingURL=HeaderAccount.js.map